// DEBUG: Constants so we don't forget to change the routes in all places when changing to the final locations.
// Inline these into those places when final.
export const CONVOV2_HOME_PAGE_ROUTE = '/convo-v2/conversations';
export const CONVOV2_APP_LAUNCH_ROUTE = '/convo-v2/launch-app';
